export const formatCustomDateTime = (dateString: string | null, onlyDate: boolean = false): string => {
  if (!dateString) return 'Not specified';
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const year = date.getFullYear();
    
    if (onlyDate) {
      return `${day} ${month}, ${year}`;
    }
    
    const time = date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit', 
      hour12: true 
    });
    
    return `${day} ${month}, ${year} ${time}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};
